import dayjs from "dayjs";

export default {
    state: {
        searchParams: {
            location: {},
            checkIn: '',
            checkOut: '',
            occupation: {
                "adults": 2,
                "children": 0,
                "rooms": 1,
                "childAges": []
            }
        }
    },
    mutations: {
        SEARCH_PARAMS(state, param) {
            if (param.type === 'location') {
                state.searchParams.location = param.selectedItem
            } else if (param.type === 'checkIn') {
                state.searchParams.checkIn = param.checkInValue
            } else if (param.type === 'checkOut') {
                state.searchParams.checkOut = param.checkOutValue
            } else if (param.type === 'occupation') {
                state.searchParams.occupation = param.occupationValue
            }
        },
        RESET_OCCUPATION(state, data) {
            if(data === '') {
                state.searchParams.occupation.adults = 2;
                state.searchParams.occupation.children = 0;
                state.searchParams.occupation.rooms = 1;
                state.searchParams.occupation.childAges = []
            }
        }
    },
    actions: {
        SEARCH_GET_LOCATION(ctx, selectedItem) {
            ctx.commit('SEARCH_PARAMS', {selectedItem, type: 'location'})
        },
        SEARCH_GET_CHECKIN(ctx, checkInValue) {
            ctx.commit('SEARCH_PARAMS', {
                checkInValue: dayjs(String(checkInValue)).format('YYYY-MM-DD'),
                type: 'checkIn'
            })
        },
        SEARCH_GET_CHECKOUT(ctx, checkOutValue) {
            ctx.commit('SEARCH_PARAMS', {
                checkOutValue: dayjs(String(checkOutValue)).format('YYYY-MM-DD'),
                type: 'checkOut'
            })
        },
        SEARCH_GET_OCCUPATION_VALUE(ctx, occupationValue) {
            ctx.commit('SEARCH_PARAMS', {occupationValue, type: 'occupation'})
        },
        RESET_OCCUPATION_VALUE(ctx, data) {
            ctx.commit('RESET_OCCUPATION', data)
        },

    },
    getters: {}
}